import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import './TransactionDetails.scss'

import breadcrumbBack from '../../../../../../BoostXpressAdmin/Assets/Icon/Stations/breadcrumb-back.svg'
import breadcrumbChevron from '../../../../../../BoostXpressAdmin/Assets/Icon/Stations/breadcrumb-chevron.svg'
 
import { TransactionXModel } from 'BoostXpressAdmin/Model/transactionXModel'
import { transactionBXService } from 'BoostXpressAdmin/Services/transactionBXService'

 

const TransactionDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const [isLoading, setIsLoading] = useState(false)
  const [transactions, setTransactions] = useState<TransactionXModel | null>(null)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!id) return
      try {
        setIsLoading(true)
        const res = (await transactionBXService.show(id))  
        if (cancelled) return
        setTransactions(res.data.data ?? null)
      } catch (e) {
        if (!cancelled) setTransactions(null)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [id])

 
 

  return (
    <div className='bx-transaction-details'>
      <div className='bx-transaction-details__breadcrumb'>
        <button className='bx-transaction-details__back' onClick={() => navigate(-1)}>
          <img src={breadcrumbBack} alt='Back' className='bx-transaction-details__back-icon' />
        </button>
        <div className='bx-transaction-details__crumbs'>
          <Link to='/boostxpress/transactions' className='bx-transaction-details__crumb-link'>
            Transactions Management
          </Link>
          <img src={breadcrumbChevron} alt='' className='bx-transaction-details__crumb-sep' />
          <span className='bx-transaction-details__crumb-current'>Transaction Details</span>
        </div>
      </div>

      <div className='bx-transaction-details__header'>
        <div className='bx-transaction-details__title-wrap'>
          <h2 className='bx-transaction-details__title'>
            {isLoading ? 'Loading...' : `Transaction #${transactions?.resourceId}`}
          </h2>
          <span
            className={`bx-transaction-details__status bx-transaction-details__status--${transactions?.paymentStatus?.toLowerCase()}`}
          >
            {transactions?.paymentStatus}
          </span>
        </div>

        <div className='bx-transaction-details__actions'>
          <button className='bx-transaction-details__btn bx-transaction-details__btn--outline'>
            Resend Receipt
          </button>
          <button className='bx-transaction-details__btn bx-transaction-details__btn--danger'>
            Flag Transaction
          </button>
        </div>
      </div>

      <div className='bx-transaction-details__cards'>
        <div className='bx-transaction-card'>
          <div className='bx-transaction-card__label'>Amount</div>
          <div className='bx-transaction-card__value'>{transactions?.amountMajor}</div>
        </div>
        <div className='bx-transaction-card'>
          <div className='bx-transaction-card__label'>Payment Processor</div>
          <div className='bx-transaction-card__value'>{transactions?.paymentProcessor}</div>
        </div>
        <div className='bx-transaction-card'>
          <div className='bx-transaction-card__label'>Description</div>
          <div className='bx-transaction-card__value'>{transactions?.description}</div>
        </div>
      </div>

      <div className='bx-transaction-details__panel'>
        <h4 className='bx-transaction-details__section-title'>Details</h4>

        <div className='bx-transaction-details__grid'>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Transaction ID</div>
            <div className='bx-transaction-details__value'>{transactions?.resourceId}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Reference</div>
            <div className='bx-transaction-details__value'>{transactions?.reference}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>User</div>
            <div className='bx-transaction-details__value'>{transactions?.user.firstName} {transactions?.user.lastName}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Email</div>
            <div className='bx-transaction-details__value'>{transactions?.user.email}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Phone</div>
            <div className='bx-transaction-details__value'>{transactions?.user.phone}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Transaction Type</div>
            <div className='bx-transaction-details__value'>{transactions?.transactionType}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Date</div>
            <div className='bx-transaction-details__value'>{transactions?.createdAt}</div>
          </div>
          <div className='bx-transaction-details__item'>
            <div className='bx-transaction-details__label'>Status</div>
            <div className='bx-transaction-details__value'>{transactions?.paymentStatus}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionDetails
